import React from "react";
import { useContent } from "@/contexts/ContentContext";
import { iconFor } from "@/lib/icons";

export const WhyChoose = () => {
    const { content } = useContent();
    const w = content.why_choose;
    const items = w.items || [];

    return (
        <section id="why-choose" data-testid="why-choose-section" className="bg-slate-50 py-24 lg:py-28">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-3xl">
                    <p className="label-eyebrow">{w.eyebrow}</p>
                    <h2 data-testid="why-choose-title" className="mt-4 font-display font-semibold text-slate-900 text-3xl sm:text-4xl lg:text-[42px] leading-[1.1] tracking-tight">{w.title}</h2>
                </div>

                <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {items.map((it, i) => {
                        const Icon = iconFor(it.icon);
                        return (
                            <article key={`${it.title}-${i}`} data-testid={`why-card-${i + 1}`} className={`card-lift bg-white border border-slate-200 p-8 ${i === 3 ? "lg:col-start-1" : ""}`}>
                                <div className="flex items-center gap-4">
                                    <span className="inline-flex items-center justify-center w-11 h-11 bg-slate-900 text-teal-300">
                                        <Icon strokeWidth={1.5} className="w-5 h-5" />
                                    </span>
                                    <span className="text-[11px] uppercase tracking-[0.2em] text-slate-400">0{i + 1}</span>
                                </div>
                                <h3 className="mt-6 font-display text-lg font-semibold text-slate-900 leading-snug">{it.title}</h3>
                                <p className="mt-3 text-[14.5px] text-slate-600 font-body leading-relaxed">{it.desc}</p>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default WhyChoose;
